module.exports = __webpack_public_path__ + "img/tab_item06.2aee0406.png";